import React, { useState } from "react";

/* Four lines is enough to know what a day was about; the rest is one click
   away rather than stretching the row. */
const Description = ({ text }) => {
    const [open, setOpen] = useState(false);
    const value = String(text || "");

    if (!value) return "--";

    /* only offer the toggle when there is plausibly more to show */
    const longEnough = value.length > 220 || value.split(/\r?\n/).length > 4;

    return (
        <span className="wh-desc">
            <span className={open ? "wh-desc-text is-open" : "wh-desc-text"}>{value}</span>
            {longEnough && (
                <button type="button" className="wh-desc-toggle"
                    onClick={() => setOpen(!open)}>
                    {open ? "Show less" : "Show more"}
                </button>
            )}
        </span>
    );
};

export default Description;
